( function () {
    'use strict';
    jQuery.extend(true, e4.settings, {
        require: {
            lottie: {
                url: 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.7.13/lottie.min.js',
                fallback: 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.7.13/lottie.min.js',
                callback: null
            }
        }
    });
}() );
